import { isAxiosError } from "axios";

import type { AssetApiClient } from "@skilitics/asset-register-api-client";

// Fetch the S3 signed url for an asset, or null if it's missing.
const getAssetSignedUrl = async (client: AssetApiClient, id: string): Promise<string | null> => {
  const response = await client.getAssetUrl(id).catch((error) => {
    // schema says it can return 307, I don't see how the implementation could though?
    if (isAxiosError(error) && error.status === 404) {
      // warn? Shouldn't be trying to load ids that don't exist
      return null;
    }
    // NOTE: temporarily stopping 504/502 errors from hitting the error boundary
    // and appearing to users as a toast. Fail silently instead so you don't get a toast error-swarm.
    console.log(error);
    return null;
  });
  if (!response) {
    return null;
  }

  return response.downloadFrom.url;
};

// Fetch the content as a Blob for an asset id, or null if it's missing.
// Used to avoid the signed URL that is returned from the API from timing out before it's
// actually fetched.
export const getAssetBlob = async (client: AssetApiClient, id: string, signal?: AbortSignal): Promise<Blob | null> => {
  const url = await getAssetSignedUrl(client, id);
  if (url) {
    const res = await fetch(url, { signal });
    if (res.status === 404) {
      // warn? means the DB and S3 are out-of-sync (probably a module import)
      return null;
    }
    return await res.blob();
  }
  return null;
};
